module.exports = __webpack_public_path__ + "img/tab_icon5.ed65f0ab.png";